import React, { ChangeEvent, FC, useState } from 'react';
import { TextField, Box, Typography, FormControl, InputLabel } from '@mui/material';
import { styled } from '@mui/system';

const DropZone = styled('div')(({ theme }) => ({
  border: '1px dashed #c4c4c4',
  borderRadius: '4px',
  padding: theme.spacing(2),
  cursor: 'pointer',
  backgroundColor: theme.palette.background.paper,
  textAlign: 'center',
  marginTop: theme.spacing(1),
  '&.dragover': {
    backgroundColor: theme.palette.action.hover,
    border: `1px dashed ${theme.palette.primary.main}`,
  },
  '&.hover': {
    backgroundColor: theme.palette.action.hover,
    border: `1px dashed ${theme.palette.primary.main}`,
  },
}));

const FileUpload: FC<{
  name: string;
  label: string;
  fieldsHandler: (e: any, isFile?: boolean) => void;
}> = ({ name, label, fieldsHandler }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(false);
    const droppedFile = e.dataTransfer.files[0];
    setFile(droppedFile);
    fieldsHandler({ target: { files: [droppedFile], name: name } }, true);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      fieldsHandler({ target: { files: [selectedFile], name: name } }, true);
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel shrink htmlFor="file-input">
          {label}
        </InputLabel>
        <TextField
          type="file"
          name={name ?? 'file'}
          onChange={handleFileChange}
          fullWidth
          InputLabelProps={{ shrink: true }}
          style={{ display: 'none' }}
          id="file-input"
        />
        <DropZone
          className={isDragOver ? 'dragover' : ''}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={() => document.getElementById('file-input')?.click()}
        >
          <Typography>Select a file or drag it here</Typography>
        </DropZone>
      </FormControl>
      {file && (
        <Box mt={2}>
          <Box mt={1} p={1} border={1} borderColor="grey.300" borderRadius={2} width={332}>
            <Typography>{file.name}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FileUpload;
